import { JSX } from 'react'

import { IconProps } from '../../icon'

const Tools: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M37.7201 14.6427L33.3573 10.2799C31.9139 8.83649 29.8965 8 27.8462 8H20.1538C18.1035 8 16.1025 8.83649 14.6427 10.2799L10.2799 14.6427C8.80369 16.1189 8 18.0707 8 20.1538V27.8462C8 29.9293 8.80369 31.8811 10.2799 33.3573L14.6427 37.7201C16.0861 39.1635 18.1035 40 20.1538 40H27.8462C29.8965 40 31.8975 39.1635 33.3573 37.7201L37.7201 33.3573C39.1963 31.8811 40 29.9293 40 27.8462V20.1538C40 18.0707 39.1963 16.1189 37.7201 14.6427ZM37.5397 27.8298C37.5397 29.2568 36.9821 30.5853 35.9815 31.6023L31.6187 35.9651C30.6345 36.9657 29.2568 37.5233 27.8462 37.5233H20.1538C18.7596 37.5233 17.3819 36.9493 16.3813 35.9651L12.0185 31.6023C11.0179 30.6017 10.4603 29.2568 10.4603 27.8298V20.1374C10.4603 18.7104 11.0179 17.3819 12.0185 16.3649L16.3813 12.0021C17.3655 11.0015 18.7432 10.4439 20.1538 10.4439H27.8462C29.2404 10.4439 30.6181 11.0179 31.6187 12.0021L35.9815 16.3649C36.9821 17.3655 37.5397 18.7104 37.5397 20.1374V27.8298Z'
      fill='black'
    />
    <path
      d='M24.0082 16.2009C19.7109 16.2009 16.2173 19.6945 16.2173 23.9918C16.2173 28.2891 19.7109 31.7827 24.0082 31.7827C28.3055 31.7827 31.7991 28.2891 31.7991 23.9918C31.7991 19.6945 28.3055 16.2009 24.0082 16.2009ZM24.0082 29.3224C21.0723 29.3224 18.6776 26.9277 18.6776 23.9918C18.6776 21.0559 21.0723 18.6612 24.0082 18.6612C26.9441 18.6612 29.3388 21.0559 29.3388 23.9918C29.3388 26.9277 26.9441 29.3224 24.0082 29.3224Z'
      fill='black'
    />
  </svg>
)

export default Tools
